import styles from "../Editor.module.scss";

const ImageBlock = ({text}) => {
    return <p className={styles.reParagraph} dangerouslySetInnerHTML={{__html: text}} />;
};

export default ImageBlock;
